<i18n
  src="@/locales/views/agro_exporter/production/basic_container_export/show_process.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/exportation.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/container.yml" lang="yaml"></i18n>
<template>
  <div class="mt-6">
    <h1 class="page-title">
      <i class="fa-solid fa-truck-container"></i><span class="space-icon"></span
      >{{ $t("labels.containers_title") }}
    </h1>
    <div class="flex flex-row justify-end">
      <div class="panel-plain-label">
        <badge-default
          :label="
            containers.length + ' ' + $t('labels.total_number_containers')
          "
        />
        <span class="space-actions" />
        <container-status
          :status_id="0"
          :prepend_label="' ' + numContainersStatus0"
        />
        <span class="space-actions" />
        <container-status
          :status_id="1"
          :prepend_label="' ' + numContainersStatus1"
        />
      </div>
      <div class="grow"></div>
      <new-button
        @click.prevent="goToNewContainer()"
        :label="$t('labels.new_container_button')"
      />
    </div>
    <div class="mt-8 flex flex-col">
      <div class="table-first-container">
        <div class="table-second-container">
          <div class="table-third-container">
            <table class="table">
              <thead class="table-header">
                <tr>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.week") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.container_code") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.exportation.status") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.packing_house") }}
                  </th>
                  <th
                    scope="col"
                    class="table-header-cell"
                    v-if="multiple_providers"
                  >
                    {{ $t("model.container.provider") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.load_date") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.customer") }}
                  </th>
                  <th scope="col" class="table-header-cell">
                    <i class="fa-solid fa-paperclip"></i>
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                  <th scope="col" class="table-header-cell">
                    {{ $t("model.container.exportation") }}
                  </th>
                  <th scope="col" class="table-header-cell"></th>
                </tr>
              </thead>
              <tbody class="table-body">
                <tr
                  class="table-row"
                  v-for="container in containers"
                  :key="container.id"
                >
                  <td class="table-cell">{{ container.week }}</td>
                  <td
                    class="table-cell-main link"
                    @click.prevent="goToShowContainer(container.id)"
                  >
                    {{ container.container_code }}
                  </td>
                  <td class="table-cell">
                    <container-status :status_id="container.status_id" />
                  </td>
                  <td class="table-cell">
                    {{ container.packing_house?.name }}
                  </td>
                  <td class="table-cell" v-if="multiple_providers">
                    {{ provider(container) }}
                  </td>
                  <td class="table-cell">
                    {{ dateFormatter(container.load_date) }}
                  </td>
                  <td class="table-cell">
                    {{ container.customer?.name }}
                  </td>
                  <td class="table-cell">
                    {{ container.num_attachments }}
                  </td>
                  <td class="table-cell">
                    <exportation-type
                      v-if="container.exportation != null"
                      :exportation_type_id="
                        container.exportation.exportation_type_id
                      "
                      :only_icon="true"
                    />
                  </td>
                  <td
                    class="table-cell link"
                    v-if="container.exportation_id"
                    @click.prevent="
                      goToShowExportation(container.exportation_id)
                    "
                  >
                    {{
                      container.exportation
                        ? container.exportation.booking_code
                        : ""
                    }}
                  </td>
                  <td class="table-cell" v-else></td>
                  <td class="table-cell-action">
                    <container-details
                      :container="container"
                      icon="fa-solid fa-eye"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerDetails from "@/components/views/agro_exporter/production/shared/container/ContainerDetails.vue";
import ContainerStatus from "@/components/views/agro_exporter/production/shared/container/ContainerStatus.vue";
import ExportationType from "@/components/views/agro_exporter/production/shared/exportation/ExportationType.vue";
import ShowProcessTabsMixin from "@/components/views/agro_exporter/production/basic_container_export/show_process/show_process_tabs_mixin.js";

export default {
  name: "ShowProcessContainers",
  mixins: [ShowProcessTabsMixin],
  components: {
    ContainerStatus,
    ExportationType,
    ContainerDetails
  },
  props: {
    containers: {
      type: Array,
      required: true
    }
  },
  computed: {
    numContainersStatus0: function () {
      let n = 0;
      this.containers.forEach(container => {
        if (container.status_id == 0) {
          n += 1;
        }
      });
      return n;
    },
    numContainersStatus1: function () {
      let n = 0;
      this.containers.forEach(container => {
        if (container.status_id == 1) {
          n += 1;
        }
      });
      return n;
    },
    multiple_providers: function () {
      return (
        this.containers
          .map(c => {
            return {
              provider_producer_id: c.provider_producer?.id,
              provider_organization_id: c.provider_organization?.id
            };
          })
          .filter((v, i, a) => {
            return (
              a.findIndex(
                t =>
                  t.provider_producer_id === v.provider_producer_id &&
                  t.provider_organization_id === v.provider_organization_id
              ) === i
            );
          }).length > 1
      );
    }
  },
  methods: {
    goToNewContainer: function () {
      this.$router.push({
        name: "ae_production_basic_container_export_new_container_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id
        }
      });
    },
    provider: function (container) {
      if (container?.provider_producer) {
        return container.provider_producer.fullname;
      } else if (container?.provider_organization) {
        return container.provider_organization.name;
      } else return "";
    },
    goToShowContainer: function (container_id) {
      this.$router.push({
        name: "ae_production_basic_container_export_show_container_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          container_id: container_id
        }
      });
    },
    goToShowExportation: function (exportation_id) {
      this.$router.push({
        name: "ae_production_basic_container_export_show_exportation_path",
        params: {
          agro_exporter_process_id: this.agro_exporter_process_id,
          exportation_id: exportation_id
        }
      });
    }
  }
};
</script>
